import {
  flowReportSchema,
  type FlowLevel,
  type FlowReport,
  type FlowSort,
  type ReportRange,
} from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * Tuzilma bo'ylab statistika — manba `subdivision/.../report.controller.ts`.
 *
 * Bitta endpoint, to'rtta daraja. `level` va `parentId` BERILMASA, server
 * doiradan kelib chiqib boshlang'ich darajani o'zi tanlaydi — shu tufayli
 * sahifa «men kimman» degan savolni hal qilmaydi.
 */
export interface FlowNode {
  level: FlowLevel;
  /** `null` — MTU darajasi, uning ustida ota yo'q. */
  parentId: string | null;
}

/**
 * Qidiruv, saralash va sahifa — hammasi SERVERDA.
 *
 * Mijozda qilib bo'lmaydi: bitta MTU da mingdan ortiq korxona bo'lishi
 * mumkin va ochiq sahifa ichida saralash «eng faol» o'rniga «shu
 * yigirmatasining eng faoli» ni ko'rsatardi.
 */
export interface FlowView {
  q: string;
  sort: FlowSort;
  page: number;
}

export interface FlowApi {
  /** `node === null` — serverning o'zi tanlasin. */
  report: (range: ReportRange, node: FlowNode | null, view: FlowView) => Promise<FlowReport>;
}

export const createFlowApi = (client: ApiClient): FlowApi => ({
  report: (range, node, view) => {
    const params = new URLSearchParams({
      from: range.from,
      to: range.to,
      sort: view.sort,
      page: String(view.page),
    });
    if (node !== null) {
      params.set('level', node.level);
      if (node.parentId !== null) params.set('parentId', node.parentId);
    }
    /* Bo'sh qidiruv UMUMAN yuborilmaydi — serverda `q=''` va `q` yo'qligi
       bir xil ma'noni anglatishi kerak, lekin buni ikki joyda ta'minlab
       yurgandan ko'ra bir joyda yubormaslik ishonchliroq. */
    if (view.q !== '') params.set('q', view.q);
    return client.apiFetch(`/reports/flow?${params.toString()}`, { schema: flowReportSchema });
  },
});

export const flowApi = createFlowApi(apiClient);
